import { createActions } from 'redux-actions';

const FLASH_MESSAGE_DISMISS_TIME = 3000;

export const { addMessage, clearMessage } = createActions(
  {
    ADD_MESSAGE: (flashMessage, messageType) => ({
      flashMessage,
      messageType,
    }),
  },
  'CLEAR_MESSAGE',
);

export const addFlashMessage = (flashMessage, messageType) => dispatch => {
  setTimeout(() => {
    dispatch(clearMessage());
  }, flashMessage[0].length * 100 + 2000);
  return dispatch(addMessage(flashMessage, messageType));
};



// WEBPACK FOOTER //
// ./src/store/actions/Flash/index.js